import React from 'react';
import '../exam/style.css';
import QuestionDetail from '../exam/components/QuestionDetail'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import mathjaxUtil from "../../utils/mathJaxUtil";

class ResultExamDetail extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            questions: this.props.questions,
            exam: this.props.exam,
        };
    }

    componentDidMount(){
        mathjaxUtil.renderMathjax(document.getElementById('final-page-exam'))
    }

    componentWillReceiveProps(nextProps){
        mathjaxUtil.renderMathjax(document.getElementById('final-page-exam'));
        this.setState({
            questions : (this.props.questions != nextProps.questions) ? nextProps.questions : this.props.questions,
            exam : (this.props.exam != nextProps.exam) ? nextProps.exam : this.props.exam,
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        mathjaxUtil.renderMathjax(document.getElementById('final-page-exam'))
    }

    render(){
        const {questions,exam} = this.state;
        let total_true = 0;
        questions.map(item => {
            if(item.type == 0){
                if(item.content.answered == item.content.correct_option){
                    total_true ++;
                }
            } else if(item.type == 1){
                if(item.content.answered == item.content.sub_question[0].correct_option){
                    total_true ++;
                }
            }
        });

        return(
            <div className="questionBody" id="final-page-exam" style={{background:"#fff", padding: "0"}}>
                <h3 className="blue">Kết quả: {exam.title}</h3>
            {    questions.map((question, index) => {
                    return (
                        <div className="questionPageXDA" key={index}>
                            <QuestionDetail index_question_active={index} activePage={3} questionDetail={question}/>
                        </div>
                    )
                })
            }
            </div>
        )
    }
}
  export default ResultExamDetail;
